const GET_EMAIL_TAB_DATA = 'default/get-tabs-data';
const Delete_COMPLAINT_URL = '/complaint/delete';
const GET_ISSUE_INFO = '/issue/info';
const ISSUE_EDIT_param = '/issue/edit-param';
const ALL_COMPLAINT_TYPES = '/issue/all-complaint-types';
const ADD_ISSUE = '/complaint/add';
const ISSUE_EDIT_WITH_PARAM = '/issue/edit-with-param';

module.exports = {

    getAllDiscussionData: function(params) {
        return window.axios.get('tabs/discussion/all', {params: params});
    },
    deleteItemComment: function(formData,flag=1) {
        return window.axios.post('booking/discussion/deleteItemComment/'+flag, formData, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        });
    },
    markDiscussionAsSeen: function(formData,flag=1) {
        return window.axios.post('booking/discussion/change-item-comment-seen-flag/'+flag, formData, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        });
    },
    getAllCallLogs: function(params) {
        return window.axios.get('webservice/get-call-log', {params: params});
    },
    getSingleTabData: function (params) {
        return window.axios.get(GET_EMAIL_TAB_DATA,{params: params});
    },
    deleteComplaint : function (complaintId){
        let params = {
            id:complaintId,
            getNewReturn:true

        };
        return window.axios.get(Delete_COMPLAINT_URL, {params: params});
    },
    getIssueInfo: function (params) {
        return window.axios.get(GET_ISSUE_INFO, {params: params});
    },
    issueEditParam: function issueEditParam(id, formData) {
        return window.axios.post(ISSUE_EDIT_param + '/' + id, formData, {
            responseType: 'json', // default
        });
    },
    issueEditWithParam: function issueEditWithParam(id, params_name,param_value) {
        let formDataInputs = new FormData();
        formDataInputs.append('param_name', params_name);
        formDataInputs.append('param_value', param_value);
        return window.axios.post(ISSUE_EDIT_WITH_PARAM + '/' + id, formDataInputs, {
            responseType: 'json', // default
        });
    },
    getAllComplaintTypes: function () {
        return window.axios.get(ALL_COMPLAINT_TYPES);
    },
    AddIssue: function Addissue(bookingId,formData) {
        return window.axios.post(ADD_ISSUE + '/' + bookingId + '?fromVue=1', formData, {
            responseType: 'json', // default
        });
    },

}